import { Grid, Typography } from "@mui/material";
import React from "react";
import { useParams } from "react-router-dom";
import useBackGroundPlanimetria from "../../Hooks/useBackgroundPlanimetria";
import { useTranslation } from "react-i18next";

export function ShowImgPlanimetria({ idZona = undefined, idStanza = undefined, nomeImgPlanimetria = "planimetria" }) {
  const params = useParams();
  const { t } = useTranslation();

  let paramsWithIdEntityFromRow = { ...params, idZona, idStanza };

  let imageBackground = useBackGroundPlanimetria(paramsWithIdEntityFromRow);

  return (
    <React.Fragment>
      <Grid container item>
        <Grid item>
          <label className="labelCustom marginToplabel">
            <Typography> {t("Floor_plan_preview")}</Typography>
          </label>
        </Grid>
        <Grid xs={12} item>
          <img
            src={imageBackground}
            alt={nomeImgPlanimetria}
            width="340"
            height="150"
          />
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
